import request from '@/utils/request'

// 店铺搜索
export function shopList(parameter) {
  return request({
    url: 'app/web/search/shopList',
    method: 'post',
    data: parameter
  })
}

// 店铺详情
export function shopInfo(parameter) {
  return request({
    url: 'app/shop/index',
    method: 'post',
    data: parameter
  })
}

// 店铺商品列表
export function shopGoods(parameter) {
  return request({
    url: 'app/shop/product',
    method: 'post',
    data: parameter
  })
}

// 公司介绍
export function shopCompany(parameter) {
  return request({
    url: 'app/shop/company',
    method: 'post',
    data: parameter
  })
}

// 公司动态
export function companyDynamics(parameter) {
  return request({
    url: 'app/shop/company/dynamics',
    method: 'post',
    data: parameter
  })
}

// 公司动态详情
export function dynamicsDetail(parameter) {
  return request({
    url: 'app/shop/company/dynamics/detail',
    method: 'post',
    data: parameter
  })
}


// 店铺banner
export function shopBanner(parameter) {
  return request({
    url: 'app/shop/shopBanner',
    method: 'post',
    data: parameter
  })
}

// 热门店铺
export function hotShop(parameter) {
  return request({
    url: 'app/web/search/rm_shopList',
    method: 'post',
    data: parameter
  })
}

// 店铺商品分类
export function productClass(parameter) {
  return request({
    url: 'app/shop/productClass',
    method: 'post',
    data: parameter
  })
}

// 增加店铺浏览量
export function addHit(parameter) {
  return request({
    url: 'app/statis/shop',
    method: 'post',
    data: parameter
  })
}

// 优铺力荐
export function shopRecommend(parameter) {
  return request({
    url: 'app/web/home/shopRecommend',
    method: 'post',
    data: parameter
  })
}

// 年度店铺推荐
export function yearTJ(parameter) {
  return request({
    url: 'app/shop/yearTJ',
    method: 'post',
    data: parameter
  })
}